<div class="space-y-4 p-6">
    <div class="flex justify-between items-center">
        <div class="flex items-center space-x-2">
            <div class="flex font-medium text-primary-400 gap-2">
                <div class="">
                    <img src="assets/svg/hierarchy.svg" alt="" class="w-5">
                </div>
                <div class="">แก้ไขราคาเซ็ต</div>
            </div>
        </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="grid grid-cols-4 gap-4">
        <!-- Products Section -->
        <div formArrayName="products" class="card col-span-full space-y-10">
            <!-- Product Table -->
            <div class="div-table">
                <table>
                    <thead>
                        <tr class="thead-tr">
                            <th class="text-left">สินค้า</th>
                            <th class="text-center w-24">จำนวนชิ้น</th>
                            <th class="text-right">ทุน(เฉลี่ยก่อนVat)</th>
                            <th class="text-right">ทุน+{{percent}}%</th>
                            <th class="text-right">ทุนรวม</th>
                            <th class="text-center w-32">ราคาขาย</th>
                            <th class="text-center w-32">ราคา SRP/ชิ้น</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Products Loop -->
                        <tr *ngFor="let product of products.controls; let i = index" [formGroupName]="i"
                            class="tbody-tr">
                            <td>
                                <div class="flex items-center gap-2">
                                    <img [src]="'https://storage.maxxgadget.com/img/product/' + product.get('sku')?.value + '/1.jpg'"
                                        alt="" class="w-10 h-10"
                                        onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                    <div class="flex-wrap min-w-44">
                                        <div class="truncate w-60">{{ product.get('name')?.value }}</div>
                                        <div class="text-primary-500">{{ product.get('sku')?.value }}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                {{ product.get('qty')?.value | number }}
                            </td>
                            <td class="text-right">{{ product.get('cost')?.value | number }}</td>
                            <td class="text-right">{{ product.get('cost_added')?.value | number }}</td>
                            <td class="text-right">{{ (product.get('cost_added')?.value * product.get('qty')?.value) |
                                number }}</td>
                            <td class="text-right">
                                <div class="w-32">
                                    <input type="number" formControlName="price" class="input" autocomplete="off"
                                        [ngClass]="{'input-invalid': ((product.get('cost_added')?.value * product.get('qty')?.value) > product.get('price')?.value) }">
                                    <div *ngIf=" ((product.get('cost_added')?.value * product.get('qty')?.value) > product.get('price')?.value) && !product.get('price')?.invalid && product.get('price')?.touched"
                                        class="error-message">
                                        ควรมากกว่าทุนรวม
                                    </div>
                                    <div *ngIf="product.get('price')?.invalid && product.get('price')?.touched"
                                        class="error-message">
                                        จำนวนขั้นต่ำ 0
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">
                                <div class="w-32">
                                    <input type="number" formControlName="srp_price" class="input" autocomplete="off"
                                        [ngClass]="{'input-invalid': ((product.get('srp_price')?.value) <= (product.get('price')?.value / product.get('qty')?.value)) }">
                                    <div *ngIf=" ((product.get('srp_price')?.value) <= (product.get('price')?.value / product.get('qty')?.value)) && !product.get('srp_price')?.invalid && product.get('srp_price')?.touched"
                                        class="error-message">
                                        ควรมากกว่าราคาขาย/ชิ้น
                                    </div>
                                    <div *ngIf="product.get('srp_price')?.invalid && product.get('srp_price')?.touched"
                                        class="error-message">
                                        จำนวนขั้นต่ำ 0
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Summary Section -->
            <div class="w-full grid grid-cols-4 gap-4 border-t border-dashed pt-6">
                <div>
                    <div>จำนวนสินค้า</div>
                    <input class="input" [value]="summaryItem()" disabled />
                </div>
                <div>
                    <div>ราคา SRP</div>
                    <input class="input" [value]="summarySRP()" disabled />
                </div>
                <div>
                    <div>ราคาเซ็ต</div>
                    <input class="input" [value]="summaryPrice()" disabled />
                </div>
                <div>
                    <div>ทุนรวมเซ็ต</div>
                    <input class="input" [value]="summaryCostAdded()" disabled />
                </div>
            </div>
        </div>
    </form>

    <div class="flex justify-center space-x-2">
        <button class="btn-sm btn-light w-32" type="button" (click)="cancel()">ยกเลิก</button>
        <button class="btn-sm btn-primary w-32" type="button" [disabled]="form.invalid"
            (click)="submit()">บันทึกข้อมูล</button>
    </div>
</div>